import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@mui/styles'

import SVGIcon from '../svg-icon/svg-icon'
import ArrowIcon from 'assets/images/icons/arrow_right.svg'
import FavoritIcon from 'assets/images/icons/favorite.svg'
import { FAVORITES_CATEGORY, setActiveCategory } from '../../../../redux/ducks/taxCategories/main'
import Badge from '../../../base/components/badge/badge'

const TaxCategoryItem = (props) => {
  const dispatch = useDispatch()
  const classes = useStyles(props)
  const { category, active } = props
  const { accountCategory } = category
  const { searchTerm } = useSelector(state => state.taxCategories.main)

  const handleItemClick = () => {
    dispatch(setActiveCategory(category))
  }

  const favoritIcon = accountCategory === FAVORITES_CATEGORY
    ? (
      <SVGIcon
        svg={FavoritIcon}
        width='15px'
        height='15px'
        customClass={classes.favoritIcon}
        fill={active ? '#fff' : 'inherit'} />
    )
    : null

  const searchBadge = searchTerm
    ? <Badge label={category.accounts.length} color={active ? 'white' : 'primary'} customClass={classes.badge} />
    : null

  return (
    <div className={`${classes.wrapper} ${active ? classes.active : ''}`} onClick={handleItemClick}>
      <span className={classes.name}>
        {favoritIcon}
        {accountCategory}
      </span>
      <div className={classes.badge}>
        {searchBadge}
      </div>
      <SVGIcon svg={ArrowIcon} height='10px' width='10px' fill={active ? '#fff' : 'inherit'} />
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '0px 20px 0px 30px',
    height: '50px',
    borderBottom: `1px solid ${theme.borderColor}`,
  },
  active: {
    background: theme.primary,
    color: '#fff',
  },
  name: {
    display: 'flex',
    alignItems: 'center',
    width: '80%',
  },
  favoritIcon: {
    marginRight: 15,
    fill: theme.primary,
  },
  badge: {
    padding: '0px 8px',
    display: 'flex',
    width: 30,
    justifyContent: 'center',
    fontSize: 12,
  },
}))

export default TaxCategoryItem
